import React from 'react';
import { Button } from 'anf-core-react';
import { useMutation } from '@apollo/client';
import TmntText from '../Common/Text/TmntText';
import { shareGiftReceiptProps } from './props';
import { useCustomTealiumTrigger } from '../../hooks/useTealiumTrigger';
import { GENERATE_GIFT_RECEIPT_MUTATION } from './operations';
import { downloadPngFromBase64 } from '../../../tools/utils';

export default function ShareGiftReceipt({ label, orderId }) {
  const analyticsData = {
    eventName: 'universal_click',
    eventData: {
      event_name: 'click',
      tealium_event: 'click',
      data_text: 'gift receipt',
      data_action: 'share',
    },
  };
  const includeDatabridgeDatapoints = false;
  const triggerAnalytics = useCustomTealiumTrigger(analyticsData, includeDatabridgeDatapoints);
  const [generateGiftReceipt, { loading }] = useMutation(GENERATE_GIFT_RECEIPT_MUTATION, {
    context: { batch: true },
    onCompleted: (data) => {
      if (data?.generateGiftReceipt?.receipt) {
        downloadPngFromBase64(data.generateGiftReceipt.receipt, orderId);
      }
    },
  });

  const onShare = () => {
    generateGiftReceipt({
      variables: {
        orderId,
      },
    });
    triggerAnalytics();
  };

  return (
    <Button variant="tertiary-light" isFullWidth onClick={onShare} isDisabled={loading}>
      <TmntText tmnt={label} />
    </Button>
  );
}

ShareGiftReceipt.propTypes = shareGiftReceiptProps;

ShareGiftReceipt.defaultProps = {
  label: {
    key: '',
    value: '',
  },
};
